<template>
  <div class="charge-edit">
    <div class="row">
      <div class="label">设备编号</div>
      <div class="row-right">
        {{ deviceInfo.primaryDeviceNo }}
      </div>
    </div>
    <div class="row">
      <div class="label">设备类型</div>
      <div class="row-right">
        {{ deviceInfo.type }}
      </div>
    </div>
    <div class="row">
      <div class="label">设备名称</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="deviceInfo.deviceName"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">设备二维码</div>
      <div class="row-right">
        {{ deviceInfo.qrCode }}
      </div>
    </div>
    <div class="row">
      <div class="label">通讯板编号</div>
      <div class="row-right">
        {{ deviceInfo.communicationBoardNo }}
      </div>
    </div>
    <div class="row">
      <div class="label">定位地址</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="deviceInfo.location" readonly></el-input>
        <i class="el-icon-location-outline icon"></i>
      </div>
    </div>
    <div class="row">
      <div class="label">投放地址</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="placingPosition.join('/')" readonly></el-input>
        <i class="el-icon-location-outline icon" @click="dialogFormVisible = true"></i>
      </div>
    </div>
    <el-dialog title="请选择投放地址" :visible.sync="dialogFormVisible">
      <el-amap-search-box
        class="search-box"
        :default="placingPosition[2]"
        :search-option="searchOption"
        :on-search-result="onSearchResult"
      ></el-amap-search-box>
      <div class="amap-page-container">
        <el-amap
          vid="amapDemo"
          :center="center"
          :zoom="zoom"
          class="amap-demo"
          :events="events">
          <el-amap-marker v-for="(marker, index) in markers" :key="index" :position="marker.position"
                          :events="marker.events" :visible="marker.visible" :draggable="marker.draggable"
                          :vid="index"></el-amap-marker>
        </el-amap>
        <div class="toolbar">
          已选位置：{{ address }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelChoose">取消</el-button>
        <el-button type="primary" @click="confirmChoose">确认</el-button>
      </div>
    </el-dialog>
    <div class="row">
      <div class="label">详细地址</div>
      <div class="row-right">
        <el-input class="fixed-width-450"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  placeholder="请输入详细地址" v-model="detailAddress">
        </el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">设备状态</div>
      <div class="row-right">
        {{ deviceInfo.enableStatus == 1 ? '启用' : (deviceInfo.enableStatus == 0 ? '停用' : '') }}
      </div>
      <div class="row-right ml10" style="color: #67aa42;" @click="changeStatus">切换状态</div>
    </div>
    <div class="row">
      <div class="normal-btn" @click="cancel">取消</div>
      <div class="blue-btn" @click="confirm">确认</div>
    </div>
  </div>
</template>
<script>
import Utils from "../../utils/utils";

export default {
  name: 'chargeMgmtEditView',
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    let self = this;
    return {
      dialogFormVisible: false,
      deviceInfo: {},
      primaryDeviceNo: '',
      placingPosition: [],
      detailAddress: '',
      searchOption: {
        city: "全国",
        citylimit: true
      },
      zoom: 12,
      center: [120.15, 30.28],
      markers: [],
      address: '',
      events: {
        click(e) {
          let {lng, lat} = e.lnglat;
          self.lng = lng;
          self.lat = lat;
          self.addMarker(lng, lat);
          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: "all"
          });
          geocoder.getAddress([lng, lat], function (status, result) {
            if (status === 'complete' && result.info === 'OK') {
              if (result && result.regeocode) {
                self.address = result.regeocode.formattedAddress;
                self.$nextTick();
              }
            }
          });
        }
      },
      lng: 0,
      lat: 0,
      qrCode: ''
    };
  },
  watch: {
    editData: {
      handler() {
        this.deviceInfo = this.editData;
        if (this.deviceInfo.editPlacingPosition) {
          this.placingPosition[0] = this.deviceInfo.editPlacingPosition.province;
          this.placingPosition[1] = this.deviceInfo.editPlacingPosition.city;
          this.placingPosition[2] = this.deviceInfo.editPlacingPosition.district;
          this.detailAddress = this.deviceInfo.editPlacingPosition.addressDetail;
        }
      },
      deep: true,
    },
  },
  mounted() {

  },
  methods: {
    onSearchResult(pois) {
      let self = this;
      let latSum = 0;
      let lngSum = 0;
      if (pois.length > 0) {
        pois.forEach(poi => {
          let {lng, lat} = poi;
          lngSum += lng;
          latSum += lat;
        });
        let center = {
          lng: lngSum / pois.length,
          lat: latSum / pois.length
        };
        this.center = [center.lng, center.lat];
        this.addMarker(center.lng, center.lat);
        var geocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: "all"
        });
        geocoder.getAddress([center.lng, center.lat], function (status, result) {
          if (status === 'complete' && result.info === 'OK') {
            if (result && result.regeocode) {
              self.address = result.regeocode.formattedAddress;
              self.$nextTick();
            }
          }
        });
      }
    },
    addMarker(lng, lat) {
      let marker = {
        position: [lng, lat],
        visible: true,
        draggable: false,
        template: '<span>1</span>'
      };
      this.markers[0] = marker;
    },
    cancelChoose() {
      this.center = [120.15, 30.28];
      this.address = '';
      this.dialogFormVisible = false;
    },
    confirmChoose() {
      let area = Utils.getArea(this.address);
      if (area) {
        this.placingPosition[0] = area.Province;
        this.placingPosition[1] = area.City;
        this.placingPosition[2] = area.Country;
        this.detailAddress = area.Address;
      }
      this.dialogFormVisible = false;
    },
    confirm() {
      this.addOrEditDevice();
    },
    cancel() {
      this.$emit('cancel');
    },
    addOrEditDevice() {
      let self = this;
      let placingPosition = {};
      if (this.placingPosition.length > 0) {
        placingPosition.province = this.placingPosition[0];
        placingPosition.city = this.placingPosition[1];
        placingPosition.district = this.placingPosition[2];
      } else {
        placingPosition.province = '';
        placingPosition.city = '';
        placingPosition.district = '';
      }
      placingPosition.addressDetail = this.detailAddress;
      let params = {
        primaryDeviceNo: this.deviceInfo.primaryDeviceNo,
        placingPosition: JSON.stringify(placingPosition),
        deviceName: this.deviceInfo.deviceName
      };
      this.$http.post('/managementPlatform/electricity/editPrimaryDeviceInfo', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "编辑成功!",
          center: true
        });
        self.$emit('editSuccess');
      }).catch(function (response) {
        console.log(response);
      });
    },
    bindQrcode(file) {
      let url = URL.createObjectURL(file.raw);
      this.$qrcode.decodeFromImage(url).then((res) => {
        this.qrCode = Utils.getQueryParam(res.data, 'qrcode');
        this.bindQrCodeToDevice();
      });
    },
    bindQrCodeToDevice() {
      let self = this;
      let params = {
        cabinetNo: this.deviceInfo.primaryDeviceNo,
        qrcode: this.qrCode,
        reconfirm: 0
      };
      this.$http.post('/managementPlatform/electricity/bindQRCode', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        if (res.mdata.needReconfirm == 1) {
          self.$confirm(res.mdata.msg, '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            self.reconfirm = 1;
            self.bindQrCodeToDevice();
          }).catch(action => {
          });
        } else {
          self.$message({
            type: "success",
            message: "绑定成功!",
            center: true
          });
          self.deviceInfo.qrcodeBindStatus = '1';
        }
      }).catch(function (response) {
        console.log(response);
      });
    },
    changeStatus() {
      let self = this;
      if (this.deviceInfo.enableStatus == 1) {
        this.$confirm('确定停用该设备？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.changeDeviceStatus(0);
        }).catch(action => {
        });
      } else {
        this.$confirm('确定启用该设备？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.changeDeviceStatus(1);
        }).catch(action => {
        });
      }
    },
    changeDeviceStatus(status) {
      let self = this;
      let params = {
        primaryDeviceNo: this.deviceInfo.primaryDeviceNo,
        enableStatus: status
      };
      this.$http.post('/managementPlatform/electricity/editPrimaryDeviceEnableStatus', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "切换成功!",
          center: true
        });
        self.deviceInfo.enableStatus = status;
      }).catch(function (response) {
        console.log(response);
      });
    }
  },
}
</script>
<style lang="scss" scoped>
.row {
  margin: 20px 0 0 20px;
  font-size: 14px;

  .fixed-width {
    width: 240px;
  }

  .row-right {
    display: inline-block;
    line-height: 30px;

    .top {
      vertical-align: top;
      color: #999999;
    }
  }

  .label {
    display: inline-block;
    vertical-align: top;
    text-align: left;
    min-width: 100px;
    margin-right: 14px;
    line-height: 25px;
  }

  .blue-btn {
    margin-right: 10px;
  }

  .table-custom {
    width: 920px;
  }

  .fixed-width-200 {
    width: 200px;
    vertical-align: top;
  }

  .fixed-width-350 {
    width: 350px;
    vertical-align: top;
  }

  .fixed-width-450 {
    width: 450px;
    vertical-align: top;
  }

  .btn {
    cursor: pointer;
  }

  .icon {
    color: #67aa42;
    font-size: 20px;
  }
}

.amap-demo {
  height: 300px;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/chargeMgmtEditView.vue